import React from "react";
import { Flame, Leaf, Wheat } from "lucide-react";

export default function KomoditasSection() {
  const items = [
    {
      icon: Flame,
      title: "Cabai",
      desc: "Basis untuk cabe bubuk & produk olahan cabai.",
    },
    {
      icon: Leaf,
      title: "Rempah Bubuk",
      desc: "Seasoning/rempah untuk kebutuhan produksi harian.",
    },
    {
      icon: Wheat,
      title: "Ketumbar",
      desc: "Komoditas penting untuk ketumbar bubuk dan bumbu.",
    },
  ];

  return (
    <section id="komoditas" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-10 items-start">
          {/* TEXT */}
          <div className="max-w-2xl">
            <span className="text-[#a00e21] font-black text-sm uppercase tracking-wider">
              Komoditas Unggulan Indonesia
            </span>

            <h2 className="mt-3 text-3xl md:text-4xl font-black text-gray-900 leading-tight">
              Rempah terbaik, sesuai kebutuhan bumbu & seasoning usaha
            </h2>

            <div className="mt-6 text-gray-700 leading-relaxed space-y-4">
              <p>
                Indonesia dikenal sebagai salah satu negara penghasil rempah terbaik di dunia
                dengan kualitas yang diakui secara global. PT Sathrusi Komoditi Indonesia
                mengelola potensi tersebut secara profesional melalui proses pengadaan bahan
                baku yang selektif, berkelanjutan, dan berorientasi pada kualitas.
              </p>
              <p>
                Komoditas seperti cabai, ketumbar, dan ragam rempah bubuk menjadi basis penting
                untuk produk SHAKTI—mulai dari cabe bubuk, bumbu tabur, hingga bumbu olahan untuk
                kebutuhan usaha.
              </p>
            </div>
          </div>

          {/* CARDS (pengganti foto stock/yang ditandai hapus) */}
          <div className="grid gap-4">
            {items.map((it) => (
              <div
                key={it.title}
                className="rounded-3xl border border-[#a00e21]/15 p-6 shadow-sm bg-white"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-[#edf011] flex items-center justify-center">
                    <it.icon className="text-[#a00e21]" />
                  </div>
                  <div>
                    <div className="font-black text-gray-900">{it.title}</div>
                    <div className="text-sm text-gray-700 mt-1">{it.desc}</div>
                  </div>
                </div>
              </div>
            ))}

           <div className="rounded-3xl border border-[#a00e21]/10 bg-[#fff5f7] p-6">
  <div className="text-sm font-extrabold text-[#a00e21]">Catatan</div>
  <div className="mt-1 text-sm text-gray-700">
    Bahan baku kami dipilih dari sentra komoditas Indonesia dan melalui seleksi kualitas
    sebelum diproses. Cabai, ketumbar, dan rempah bubuk menjadi fondasi produk SHAKTI
    untuk rasa yang konsisten di kebutuhan usaha maupun rumahan.
  </div>
</div>

          </div>
        </div>
      </div>
    </section>
  );
}
